import { React, PropTypes, DatePickerField, injectIntl, config, InputWrapper, Utils } from '../../../dependencies';

function TaxableFulfillmentDue({ intl, disabled }) {
    return (
        <InputWrapper>
            <DatePickerField
                {...{
                    name: 'taxableFulfillmentDue',
                    label: intl.formatMessage({
                        id: 'expense.form.taxableFulfillmentDue.label',
                    }),
                    displayFormat: config.date,
                    disabled,
                    allowClear: false,
                    parse: Utils.parseMomentDateInput,
                }}
            />
        </InputWrapper>
    );
}

TaxableFulfillmentDue.propTypes = {
    intl: PropTypes.shape().isRequired,
    disabled: PropTypes.bool.isRequired,
};

export default injectIntl(TaxableFulfillmentDue);
